import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useAuth } from '../hooks/useAuth';
import { FeedbackForm } from '../components/forms/FeedbackForm';

export const FeedbackPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted/20 py-4 sm:py-8 lg:py-12 px-4 sm:px-6">
      <Helmet>
        <title>Wallstreetle | Send Feedback</title>
        <meta name="description" content="Send feedback, report bugs, or suggest features for Wallstreetle - the stock wordle and finance wordle game. Help us improve!" />
        <meta name="keywords" content="Wallstreetle feedback, contact, bug report, feature request, stock wordle feedback, finance wordle support" />
        <link rel="canonical" href="https://wallstreetle.com/feedback" />

        {/* Open Graph */}
        <meta property="og:title" content="Wallstreetle | Send Feedback" />
        <meta property="og:description" content="Send feedback, report bugs, or suggest features for Wallstreetle." />
        <meta property="og:url" content="https://wallstreetle.com/feedback" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Send Feedback - Wallstreetle",
            "description": "Send feedback, report bugs, or suggest features for Wallstreetle - the stock wordle and finance wordle game.",
            "url": "https://wallstreetle.com/feedback",
            "inLanguage": "en-US",
            "author": {
              "@type": "Person",
              "name": "Wallstreetle Team",
              "url": "https://wallstreetle.com"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Wallstreetle",
              "logo": {
                "@type": "ImageObject",
                "url": "https://wallstreetle.com/logo512.png",
                "width": 512,
                "height": 512
              }
            },
            "isPartOf": {
              "@type": "WebSite",
              "name": "Wallstreetle",
              "url": "https://wallstreetle.com"
            }
          })}
        </script>
      </Helmet>
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 sm:gap-6 lg:gap-8">
        {/* Header */}
        <div className="space-y-2 sm:space-y-3">
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-wide text-primary/80">
            Help Us Improve
          </p>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground">
            Send Feedback
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground">
            Found a bug? Have a feature idea? Wrong stock info? Let us know! Your feedback helps make Wallstreetle better for everyone.
          </p>
        </div>

        {/* Form */}
        <FeedbackForm userEmail={user?.email || ''} />
      </div>
    </div>
  );
};

export default FeedbackPage;
